// 预约相关接口
import {
    getAreaConfigListByApi,
    getActivityInfoByApi,
    type areaConfigInfoType,
} from '@efe-activity-fe-util/core'
import { AREA_CONFIG } from '../constants/pre'

export function useBackstage() {
    let activityConfig:
        | Awaited<ReturnType<typeof getActivityInfoByApi>>['data']
        | null = null
    let areaConfigList: areaConfigInfoType[] = []

    const getActivityConfig = async () => {
        const { data } = await getActivityInfoByApi('payType')

        try {
            data.activityMsgConfig.activityMsg.context = JSON.parse(
                data.activityMsgConfig.activityMsg.context ?? '{}'
            )

            data.activityMsgConfig.activityMsg.payType = JSON.parse(
                data.activityMsgConfig.activityMsg.payType ?? '{}'
            )
        } catch (error) {
            //
        }

        activityConfig = data
        return activityConfig ?? {}
    }

    const getAreaConfig = async () => {
        if (!areaConfigList.length) {
            const { code, data } = await getAreaConfigListByApi()
            if (code === 'e1000' && data) {
                areaConfigList = data.filter((val) =>
                    AREA_CONFIG.find(({ code }) => code === val.areaCode)
                )
            }
        }
        return areaConfigList
    }

    return {
        getActivityConfig,
        getAreaConfig,
    }
}
